import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import './index.css';
import { router } from './app/router';
import {
  LoadingState,
  ErrorBoundary,
  AdvancedPageTransition,
} from '@/shared/components';
import WithQuery from './app/providers/query-client';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WithQuery>
      <ErrorBoundary>
        <AdvancedPageTransition>
          <Suspense
            fallback={<LoadingState size='lg' text='Loading The Sanur...' />}
          >
            <RouterProvider router={router} />
          </Suspense>
        </AdvancedPageTransition>
      </ErrorBoundary>
      <Toaster
        position='top-right'
        expand={true}
        richColors={true}
        closeButton={true}
      />
    </WithQuery>
  </StrictMode>
);
